import { useCallback } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';

export const useNavigationService = () => {
  const navigate = useNavigate();

  const navigateTo = useCallback(
    (path: string | number, queryParams = {}, state: unknown = null) => {
      const search = createSearchParams(queryParams).toString();

      if (typeof path === 'string') {
        if (state !== null) {
          navigate({ pathname: path, search }, { state });
        } else {
          navigate({ pathname: path, search });
        }
      } else {
        navigate(path);
      }
    },
    [navigate],
  );

  return { navigateTo };
};
